import { Component, effect, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../../shared'
import { GridSelectionCalculationComponent } from '../../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-hours-variance',
    templateUrl: './hours-variance.component.html',
    standalone: true,
    imports: [WjGridModule, AutoSizeDirective, WjGridFilterModule, GridSelectionCalculationComponent],
})
export class HoursVarianceComponent extends BaseComponent {
    active = input.required<number>()
    hoursVarianceGrid: Grid<any>

    constructor() {
        super()

        this.hoursVarianceGrid = new Grid<any>(this.services)

        effect(() => {
            if (this.active() === 11) {
                this.refresh()
            }
        })
    }

    refresh() {
        this.cancelableRequest(
            'GetHoursVarianceAnalytics',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/FuelAnalytics/GetHoursVarianceAnalytics')).subscribe({
                next: result => {
                    this.hoursVarianceGrid.items = result[0]
                },
            }),
        )
    }
}
